/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { ArrowDropDown, Close } from '@mui/icons-material';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import { Box, Button, Grid, IconButton, Skeleton, Stack, Tab, Typography, Link, Breadcrumbs, useTheme, Tabs, Theme, Hidden } from '@mui/material';
import { Location } from 'history';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { calculateOthersInPieChart, formatCurrency, formatToIndianCurrency } from '../../utils/utilityFunctions';
import { CommonLayout, FilterDrawer } from '../commonComponents';
import FilterPortal from './filter-portal';
import ProductDebt from './product-debt';
import ProductEquity from './product-equity';
import ProductOverview from './product-overview';
import SchemeDetails from './product-scheme-details';
import TransactionDetails from './product-transaction-details';
import DashboardLayout from './dashboard-layout';
import { useHistory } from 'react-router';
import { NavigateNext as NavigateNextIcon } from '@mui/icons-material';
import { ChartIcon, CurrencyIcon, MoneyGrow, TotalInvestors } from '../../assets/SvgIcons';
import BreadCrum from '../../lib/BreadCrum';
import { RootStateType } from '../../redux-store/reducers';
import { amcPerformanceDownload, getCategoryWiseDistribution, getProductsAMCPerformance, getSchemeDetails, getSebiAssetAllocation, getTransactionDetails, totalCardValuesApi } from '../../redux-store/actions/product';
import { AMCPerformanceProductsRes, CategoryWiseDistibutionRes, GetSchemeDetailsResponseBody, GetTransactionDetailsResponseBody, SchemeDetail, SebiAssetAllocationRes, TotalCardValuesRes, TransactionDetailsData } from '../../redux-store/types/products';
import { Order, PaginationObj, SortingObj } from '../investorOverview/types';
import { SidebarCardProps } from '../investorOverview/bonds/types';
import { ZeroStateInvestment } from '../investorOverview/common/ZeroStateInvestment';
import { reportDownload } from '../Reports/report-utils';
import { setAppliedFundsFilters, setAppliedHoldingsFilters, setAppliedSystematicPlansFilters, setCheckedHoldingSchemes, setExploreMutualFundsPageVisited, setHoldingsActiveCategory, setSelectedAllHoldingsInfo, setSelectedHoldingsIds, setSelectedHoldingsInfo, setSelectedSchemesObj, setSystematicPlansSearchText } from '../../redux-store/actions/investorProfile';

export function ProductTopSection({
  marketValue,
  investedValue,
  gainLoss,
  isLoading,
  xirr,
}: {
  marketValue?: number;
  investedValue?: number;
  gainLoss?: number;
  isLoading?: boolean;
  xirr?: number | null;
}) {

  const valueConverter = useSelector((state: any) => state.valueConverter)
  return (
    <Box
      sx={{
        background: ' #FFFFFF',
        boxShadow: '0px 4px 28px 2px rgba(0, 0, 0, 0.08)',
        borderRadius: '5px',
        mb: 7,
        py: 2.5,
        px: [2, 2, 5, 7],
      }}>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={3}>
          <Typography sx={{ fontSize: [12, 12, 13, 16], lineHeight: '19px', color: '#22242C' }}>
            Current Market Value
          </Typography>
          {isLoading ? (
            <Skeleton />
          ) : (
            <Typography
              sx={{
                fontSize: [16, 16, 16, 20],
                lineHeight: '24px',
                color: '#000',
                fontWeight: 700,
              }}>
              {marketValue ? `${formatToIndianCurrency(marketValue, valueConverter)}` : 'NA'}
            </Typography>
          )}
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Typography sx={{ fontSize: [12, 12, 13, 16], lineHeight: '19px', color: '#22242C' }}>
            Invested Value
          </Typography>
          {isLoading ? (
            <Skeleton />
          ) : (
            <Typography
              sx={{
                fontSize: [16, 16, 16, 20],
                lineHeight: '24px',
                color: '#000',
                fontWeight: 700,
              }}>
              {investedValue ? `${formatToIndianCurrency(investedValue, valueConverter)}` : 'NA'}
            </Typography>
          )}
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Typography sx={{ fontSize: [12, 12, 13, 16], lineHeight: '19px', color: '#22242C' }}>
            Gain/Loss
          </Typography>
          {isLoading ? (
            <Skeleton />
          ) : (
            <Typography
              sx={{
                fontSize: [16, 16, 16, 20],
                lineHeight: '24px',
                color: '#000',
                fontWeight: 700,
              }}>
              {gainLoss ? `${formatToIndianCurrency(gainLoss, valueConverter)}` : 'NA'}
            </Typography>
          )}
        </Grid>
        {xirr !== null ? (
          <Grid item xs={12} sm={6} md={3}>
            <Typography sx={{ fontSize: [12, 12, 13, 16], lineHeight: '19px', color: '#22242C' }}>
            Absolute Return
            </Typography>
            {isLoading ? (
              <Skeleton />
            ) : (
              <Typography
                sx={{
                  fontSize: [16, 16, 16, 20],
                  lineHeight: '24px',
                  color: xirr && xirr < 0 ? '#DC3636' : '#9FD8BE',
                  fontWeight: 700,
                }}>
                {xirr ? `${xirr}%` : 'NA'}
              </Typography>
            )}
          </Grid>
        ) : null}
      </Grid>
    </Box>
  );
}

// const defaultFilters = {};

export default function ProductDetails({
  location,
}: {
  location: Location<{ investorId: string; investorName: string }>;
}): JSX.Element {
  const { palette } = useTheme()
  // const { investorId, investorName } = location?.state || { investorId: '', investorName: '' };
  // const history = useHistory();
  // const [value, setValue] = useState<string>('overview');
  // const [assetTypes, setAssetTypes] = useState<string[]>([]);
  // const [filterElementLoading, setFilterElementLoading] = useState<boolean>(true);
  // const [filterMenuAnchorEl, setFilterMenuAnchorEl] = useState<null | HTMLElement>(null);
  // const filterMenuOpen = Boolean(filterMenuAnchorEl);
  // const [selectedFilters, setSelectedFilters] =
  //   useState<{ [key: string]: string[] }>(defaultFilters);
  // const handleChange = (event: React.SyntheticEvent, newValue: string) => {
  //   setValue(newValue);
  // };
  // const [viewAllSelectedFilters, setViewAllSelectedFilters] = useState(false);
  // let filtersSelected = ([] as string[]).concat(...Object.values(selectedFilters));
  // filtersSelected =
  //   filtersSelected.length > 3 && !viewAllSelectedFilters
  //     ? filtersSelected.slice(0, 3)
  //     : filtersSelected;
  // useEffect(() => {
  //   setTimeout(() => setFilterElementLoading(false), 1);
  // }, []);
  // useEffect(() => {
  //   setSelectedFilters(defaultFilters);
  // }, [value]);

  // const selectedFilterElements = (
  //   <Box
  //     sx={{
  //       bgcolor: 'common.white',
  //       boxShadow: '0px 4px 28px 2px rgba(0, 0, 0, 0.08)',
  //       borderRadius: '5px',
  //       mb: 7,
  //       display: 'flex',
  //       flex: 1,
  //       justifyContent: 'space-between',
  //       p: 2,
  //       width: '100%',
  //     }}>
  //     <Stack
  //       direction="row"
  //       alignItems="center"
  //       sx={{ flex: 1, flexWrap: 'wrap', gap: 1 }}
  //       spacing={1}>
  //       {filtersSelected.map((each) => (
  //         <Box
  //           key={each}
  //           sx={{
  //             background: '#D9D9D9',
  //             p: '6px 8px',
  //             borderRadius: '9px',
  //             display: 'flex',
  //             cursor: 'pointer',
  //           }}>
  //           <Typography sx={{ color: '#323232' }}>{each}</Typography>
  //           <Close
  //             sx={{ color: '#6D6868', width: 16, ml: 1 }}
  //             onClick={() => {
  //               const updatedFilters = { ...selectedFilters };
  //               Object.keys(updatedFilters).map((eachSection) => {
  //                 if (selectedFilters?.[eachSection]?.includes(each)) {
  //                   updatedFilters[eachSection] = selectedFilters?.[eachSection].filter(
  //                     (val) => val !== each
  //                   );
  //                 } else {
  //                   updatedFilters[eachSection] = selectedFilters?.[eachSection];
  //                 }
  //               });
  //               setSelectedFilters(updatedFilters);
  //             }}
  //           />
  //         </Box>
  //       ))}
  //     </Stack>
  //     {([] as string[]).concat(...Object.values(selectedFilters)).length > 3 && (
  //       <Button
  //         endIcon={<ArrowDropDown />}
  //         sx={{
  //           fontSize: 14,
  //           lineHeight: '16px',
  //           color: '#4E5056',
  //           fontWeight: 500,
  //           padding: '4px 22px',
  //           boxShadow: '1px 1px 3px rgba(0, 0, 0, 0.15)',
  //           border: '1px solid #0BAAE7',
  //           borderRadius: '5px',
  //           height: 'fit-content',
  //         }}
  //         onClick={() => setViewAllSelectedFilters(!viewAllSelectedFilters)}>
  //         {viewAllSelectedFilters ? 'View Less' : ' View all'}
  //       </Button>
  //     )}
  //   </Box>
  // );
  // const breadcrumbs = location.pathname.includes('/product')
  //   ? [
  //     <Typography key="1" sx={{ color: '#767676 !important' }}>
  //       Products
  //     </Typography>,
  //     <Typography key="2" color="text.primary">
  //       {location.pathname.includes('/mutual-fund')
  //         ? 'Mutual Fund'
  //         : location.pathname.includes('/direct-equity')
  //           ? 'Direct Equity'
  //           : location.pathname.includes('/pms')
  //             ? 'PMS'
  //             : location.pathname.includes('/aif')
  //               ? 'AIF'
  //               : null}
  //     </Typography>,
  //   ]
  //   : [
  //     investorId ? (
  //       <Link
  //         key="2"
  //         sx={{ cursor: 'pointer', textDecoration: 'none' }}
  //         onClick={() => history.push('/investor', { investorId, investorName })}>
  //         {investorName}
  //       </Link>
  //     ) : null,
  //     location.pathname.includes('mutual-fund') ||
  //       location.pathname.includes('direct-equity') ||
  //       location.pathname.includes('pms') ||
  //       location.pathname.includes('aif') ? (
  //       <Typography key="3" color="text.primary">
  //         {location.pathname.includes('mutual-fund')
  //           ? 'Mutual Fund'
  //           : location.pathname.includes('direct-equity')
  //             ? 'Direct Equity'
  //             : location.pathname.includes('/pms')
  //               ? 'PMS'
  //               : location.pathname.includes('/aif')
  //                 ? 'AIF'
  //                 : null}
  //       </Typography>
  //     ) : null,
  //   ];

  type CardProps = {
    Icons: (props: React.SVGProps<SVGSVGElement>) => JSX.Element
    title: string
    value: string
    color?: string
    percent?: boolean
    percentageValue?: number
  }

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const Card = (props: CardProps) => {
    const { Icons, title, value, color, percent, percentageValue } = props
    const { palette } = useTheme()
    return (
      <Box sx={{ display: 'flex', flexDirection: 'row', gap: '10px', borderRadius: '15px', padding: '0px 18px', height: '102px', boxShadow: '0 4px 10px rgba(0, 0, 0, 0.05)', background: palette.common.white }} >

        {/* Card Icon */}
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <Icons />
        </Box>
        {/* Card Title - Subtitle */}
        <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', gap: '10px', width: '80%' }}>
          {isLoading ? <>
            <Skeleton animation="wave" sx={{ width: '60%' }} />
            <Skeleton animation="wave" sx={{ width: '100%' }} />
          </> : <>
            <Typography variant="subtitle_500" color={palette.text.primary} sx={{ lineHeight: '14px' }}>{title}</Typography>
            {!percent ? <Typography variant="h3" color={color ? color : palette.text.primary} sx={{ textWrap: 'nowrap' }}>{value}</Typography> : <Typography variant="h3" color={color ? color : palette.text.primary} sx={{ textWrap: 'nowrap' }}>{`${value}(${percentageValue ? percentageValue.toFixed(2) : '0'}%)`}</Typography>}
          </>}
        </Box>
      </Box>
    )
  }



  interface InfoCardProps {
    Icon: (props: React.SVGProps<SVGSVGElement>) => JSX.Element
    title: string
    value: number
    valueTextColor?: string
    isLoading: boolean
    percentage?: number
  }

  interface FetchDataArgs {
    sortItem?: string;
    order?: Order;
    currentPage?: number;
    rowsPerPage?: number;
  }
  function InfoCard({
    Icon,
    title,
    value,
    valueTextColor = "text.primary",
    isLoading,
    percentage
  }: InfoCardProps) {
    const { locale, currencyCode } = useSelector((store: RootStateType) => store.currencyInfo);

    const formatedPercentage = !Number.isNaN(Number(percentage ?? 0)) ?
      Math.round((percentage ?? 0) * 100) / 100 : '0'
    return (
      <Box
        sx={(theme: Theme) => ({
          backgroundColor: theme.palette.common.white,
          borderRadius: "15px",
          boxShadow: `0px 4px 10px 0px ${theme.palette.common.black}0D`,
          padding: { xs: "10px 5px", sm: "25px 18px" },
          display: "flex",
          alignItems: 'center',
          height: '100%'
        })}
      >
        <Box
          sx={{
            flex: 1,
            display: "flex",
            justifyContent: "center",
          }}
        >

          <Icon />
        </Box>
        <Box
          sx={{
            flex: 3,
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-end",
            rowGap: "8px",
            width: '80%',
          }}
        >
          {isLoading && (
            <>
              <Skeleton
                animation="wave"
                sx={{ width: '60%' }}
              />
              <Skeleton
                animation="wave"
                sx={{ width: '100%' }}
              />
            </>
          )}
          {!isLoading && (
            <>
              <Typography
                variant="subtitle_500"
                sx={(theme: Theme) => ({
                  lineHeight: "14px",
                  color: theme.palette.text.primary,
                })}
              >
                {title}
              </Typography>
              <Typography
                variant="h3"
                sx={{
                  lineHeight: "27.5px",
                  color: valueTextColor
                }}
              >
                {title === "Market Value" && (
                  (value ?? 0) < 0 ? `- ${formatCurrency({ value: Math.abs(value ?? 0), locale, currencyCode })}` : `${formatCurrency({ value: value ?? 0, locale, currencyCode })}`
                )}
                {title === "Invested Value" && (
                  (value ?? 0) < 0 ? `- ${formatCurrency({ value: Math.abs(value ?? 0), locale, currencyCode })}` : `${formatCurrency({ value: value ?? 0, locale, currencyCode })}`
                )}
                {title === "Gain/Loss (%)" && (
                  (value ?? 0) < 0 ? `- ${formatCurrency({ value: Math.abs(value ?? 0), locale, currencyCode })} (${formatedPercentage}%)` : `${formatCurrency({ value: value ?? 0, locale, currencyCode })} (${formatedPercentage}%)`
                )}
                {title === "Absolute Return %" && (
                  !Number.isNaN(Number(value ?? 0)) ?
                    `${Math.round((value ?? 0) * 100) / 100} %` : '0 %'
                )}
                {title === "Total Investors" && (
                  value ?? 0
                )}
              </Typography>
            </>
          )}
        </Box>

      </Box>
    )
  }
  const productMutualFundTabs = ['Overview', 'Scheme Details', 'Transaction Details'];

  const [mutualFundTab, setMutualFundTab] = useState("Overview");
  const dispatch = useDispatch()
  const {
    role = '',
  } = useSelector((store: RootStateType) => store.auth);
  const { iwappRmId } = useSelector((store: RootStateType) => store.id)
  const {
    selectedPortfolio
  } = useSelector((store: RootStateType) => store.selectedPortfiolio);

  const history = useHistory();
  const { pathname: pathName, state } = history.location
  const initialRouter = pathName.split('/').filter((item) => item !== '')

  // console.log('path', initialRouter, pathName)

  const rmRouterPath = [
    {
      name: 'Dashboard',
      path: '/dashboard',
      // warning: true
    },
    {
      name: 'Mutual Funds',
      path: `/${initialRouter[0]}/${initialRouter[1]}`,
    }
  ]

  const initialMFCardsArray = [
    {
      Icon: (props: React.SVGProps<SVGSVGElement>) => <MoneyGrow {...props} viewBox="0 0 57 50" />,
      title: "Market Value",
      value: 0
    },
    {
      Icon: (props: React.SVGProps<SVGSVGElement>) => <CurrencyIcon {...props} />,
      title: "Invested Value",
      value: 0
    },
    {
      Icon: (props: React.SVGProps<SVGSVGElement>) => <ChartIcon {...props} viewBox="0 0 57 50" />,
      title: "Gain/Loss (%)",
      value: 0,
      percentage: 0,
      valueTextColor: 'success.500'
    },
    {
      Icon: (props: React.SVGProps<SVGSVGElement>) => <TotalInvestors {...props} viewBox="0 0 57 50" />,
      title: "Total Investors",
      value: 0
    }
  ]
  const [cardValuesLoading, setCardValuesLoading] = useState(false);
  const [mutualFundCardObj, setMutualFundCardObj] = useState<{ isSuccess: boolean; data: SidebarCardProps[] }>({ isSuccess: true, data: initialMFCardsArray })


  // Overview States and apis
  const [productsOverviewLoader, setProductsOverviewLoader] = useState<boolean>(false);
  const [productsOverviewData, setProductsOverviewData] = useState<CategoryWiseDistibutionRes>({} as CategoryWiseDistibutionRes)
  const [sebiAllocationData, setSebiAllocationData] = useState<SebiAssetAllocationRes>({} as SebiAssetAllocationRes)
  const [amcPerformanceData, setAMCPerformanceData] = useState<AMCPerformanceProductsRes>({} as AMCPerformanceProductsRes)
  const [sortingObj, setSortingObj] = useState<SortingObj>({ order: "desc", orderBy: "investedValue" })
  const [amcSortingObj, setAMCSortingObj] = useState<SortingObj>({ order: "desc", orderBy: "investedValue" })
  const [amcLoader, setAmcLoader] = useState<boolean>(false)
  const [amcDownloadLoader, setAmcDownloadLoader] = useState<boolean>(false);
  const [assetLoading, setAssetLoading] = useState<boolean>(false);

  const getProductsOverviewDetails = async (orderBy = 'investedValue', order = 'desc') => {
    try {
      setProductsOverviewLoader(true);
      const productOverviewRes = await (dispatch(getCategoryWiseDistribution({
        rmId: `${iwappRmId}`,
        sortItem: orderBy,
        order: order,
        assetGroup: "MF"
      })) as unknown as Promise<CategoryWiseDistibutionRes>)
      setProductsOverviewData({ ...productOverviewRes, result: { ...productOverviewRes?.result, categoryWiseDistribution: { ...productOverviewRes?.result?.categoryWiseDistribution } } })
    } catch (e) {
      console.log('Error', e);
    } finally {
      setProductsOverviewLoader(false)
    }

  }

  const getSebiAllocationDetails = async () => {
    try {
      setAssetLoading(true);
      const sebiAllocationRes = await (dispatch(getSebiAssetAllocation({
        rmId: `${iwappRmId}`,
        assetGroup: "MF"
      })) as unknown as Promise<SebiAssetAllocationRes>)
      setSebiAllocationData({ ...sebiAllocationRes, result: { ...sebiAllocationRes?.result } })
    } catch (e) {
      console.log("Error", e)
    } finally {
      setAssetLoading(false);
    }
  }

  const getProductLevelAMCPerformance = async (orderBy = 'investedValue', order = 'desc') => {
    try {
      setAmcLoader(true);
      const amcPerformancePayload = {
        rmId: `${iwappRmId}`,
        sortItem: orderBy,
        order: order,
        assetGroup: "MF"
      }
      const amcPerformanceRes = await (dispatch(getProductsAMCPerformance(amcPerformancePayload)) as unknown as Promise<AMCPerformanceProductsRes>)
      setAMCPerformanceData(amcPerformanceRes)
    } catch (e) {
      console.log("Error", e);
    } finally {
      setAmcLoader(false);
    }

  }

  // Scheme Details State and apis
  const [schemeDetailsLoading, setSchemeDetailsLoading] = useState<boolean>(false);
  const [tableData, setTableData] = useState<SchemeDetail[]>([])
  const [tablePaginationObj, setTablePaginationObj] = useState<PaginationObj>({
    currentPage: 0,
    rowsPerPage: 5,
    totalRows: 0
  })
  const [schemeDetailsData, setSchemeDetailsData] = useState<GetSchemeDetailsResponseBody>({} as GetSchemeDetailsResponseBody)

  // Transaction Details states and apis

  const [transactionDetailsLoading, setTransactionDetailsLoading] = useState<boolean>(false);
  const [transactionTableData, setTransactionTableData] = useState<TransactionDetailsData[]>([])
  const [transactionDetailPaginationObj, setTransactionDetailPaginationObj] = useState<PaginationObj>({
    currentPage: 0,
    rowsPerPage: 5,
    totalRows: 0
  })
  const [transactionDetailsData, setTransactionDetailsData] = useState<GetTransactionDetailsResponseBody>({} as GetTransactionDetailsResponseBody)

  const fetchTransactionDetailsData = async ({
    sortItem = "date",
    order = "desc",
    currentPage = 1,
    rowsPerPage = 5
  }: FetchDataArgs = {}) => {
    try {
      setTransactionDetailsLoading(true)

      const payload = {
        rmId: iwappRmId,
        sortItem,
        order,
        currentPage,
        rowsPerPage,
      }

      const transactionDetailsRes = await (dispatch(getTransactionDetails(payload)) as unknown as Promise<GetTransactionDetailsResponseBody>)
      setTransactionDetailsData(transactionDetailsRes)

      if (transactionDetailsRes?.isSuccess) {
        setTransactionTableData(transactionDetailsRes?.result)
        setTransactionDetailPaginationObj(prevState => ({
          ...prevState,
          totalRows: transactionDetailsRes?.totalLength
        }))
      } else {
        console.log(transactionDetailsRes?.message)
      }

    } catch (error) {
      console.log("Error: ", error)
    } finally {
      setTransactionDetailsLoading(false)
    }
  }

  const totalCardValues = async () => {
    try {
      setCardValuesLoading(true);
      const cardValuesRes = await (dispatch(totalCardValuesApi({
        rmId: `${iwappRmId}`,
        category: '',
        assetGroup: "MF"
      })) as unknown as Promise<TotalCardValuesRes>)
      if (cardValuesRes?.isSuccess) {
        setMutualFundCardObj(prevState => ({
          isSuccess: true,
          data: prevState.data.map((obj: SidebarCardProps) => {
            if (obj.title === "Market Value") {
              return {
                ...obj,
                value: cardValuesRes?.result?.totalMarketValue ?? 0
              }
            }
            if (obj.title === "Invested Value") {
              return {
                ...obj,
                value: cardValuesRes?.result?.totalInvestedValue ?? 0
              }
            }
            if (obj.title === "Gain/Loss (%)") {
              return {
                ...obj,
                value: cardValuesRes?.result?.gainLoss ?? 0,
                percentage: cardValuesRes?.result?.percentage ?? 0,
                valueTextColor: (cardValuesRes?.result?.gainLoss ?? 0) >= 0 ? 'success.500' : 'error.500'
              }
            }
            if (obj.title === "Absolute Return %") {
              return {
                ...obj,
                value: cardValuesRes?.result?.irr ?? 0
              }
            }

            if (obj.title === "Total Investors") {
              return {
                ...obj,
                value: cardValuesRes?.result?.totalInvestors ?? 0
              }
            }
            return obj
          })
        }))
      }
      else {
        setMutualFundCardObj({
          isSuccess: false,
          data: initialMFCardsArray
        })
      }
      return cardValuesRes?.isSuccess;

    } catch (e) {
      console.log("Error", e);
    } finally {
      setCardValuesLoading(false);
    }
  }




  const fetchSchemeDetailsData = async ({
    sortItem = "investedValue",
    order = "desc",
    currentPage = 1,
    rowsPerPage = 5
  }: FetchDataArgs = {}) => {
    try {
      setSchemeDetailsLoading(true)
      const payload = {
        rmId: iwappRmId,
        sortItem,
        order,
        currentPage,
        rowsPerPage,
        assetGroup: 'MF'
      }
      const schemeDetailsRes = await (dispatch(getSchemeDetails(payload)) as unknown as Promise<GetSchemeDetailsResponseBody>)
      setSchemeDetailsData(schemeDetailsRes);
      if (schemeDetailsRes?.isSuccess) {
        setTableData(schemeDetailsRes?.result)
        setTablePaginationObj(prevState => ({
          ...prevState,
          totalRows: schemeDetailsRes?.totalLength
        }))
      } else {
        console.log(schemeDetailsRes?.message)
      }

    } catch (error) {
      console.log("Error: ", error)
    } finally {
      setSchemeDetailsLoading(false)
    }
  }

  useEffect(() => {
    const fetchInitialData = async () => {
      setIsLoading(true);
      const isSuccess = await totalCardValues();
      if (isSuccess) {
        if (mutualFundTab === 'Overview') {
          await Promise.allSettled([getProductsOverviewDetails(), getSebiAllocationDetails(), getProductLevelAMCPerformance()])
        }

        if (mutualFundTab === 'Scheme Details') {
          fetchSchemeDetailsData();
        }
        if (mutualFundTab === "Transaction Details") {
          fetchTransactionDetailsData();
        }
      }
      setIsLoading(false);
    }
    fetchInitialData();
  }, [])

  const currentInvestedValueObj = mutualFundCardObj
    .data
    .find(obj => obj.title === "Invested Value");
  const portfolioNotExistStatus = Number(currentInvestedValueObj?.value ?? 0) === 0

  const handleTabChange = async (currentTab: string) => {
    setMutualFundTab(currentTab)

    if (currentTab === "Overview") {
      setSortingObj({ order: "desc", orderBy: "investedValue" })
      setAMCSortingObj({ order: "desc", orderBy: "investedValue" })

      await Promise.allSettled([getProductsOverviewDetails(), getSebiAllocationDetails(), getProductLevelAMCPerformance()])
    }

    if (currentTab === "Scheme Details") {
      setTablePaginationObj({
        currentPage: 0,
        rowsPerPage: 5,
        totalRows: 0
      })

      fetchSchemeDetailsData();
    }
    if (currentTab === "Transaction Details") {
      setTransactionDetailPaginationObj({
        currentPage: 0,
        rowsPerPage: 5,
        totalRows: 0
      })

      fetchTransactionDetailsData();
    }
  }

  const amcDownloadHandler = async () => {
    try {
      setAmcDownloadLoader(true);

      const formatExportedData = [
        {
          "amcname": "AMC NAME",
          "marketValue": "MARKET VALUE",
          "equity": "EQUITY",
          "debt": "DEBT",
          "hybrid": "HYBRID",
          "others": "OTHERS",
          "investedValue": "INVESTED VALUE",
          "unRelease": "UNREALISED GAIN/LOSS",
          "release": "REALISED GAIN/LOSS",
          "dividend": "DIVIDEND",
          "irr": "ABSOLUTE RETURN",
          "holding": "HOLDING"
        },
        ...amcPerformanceData.result
      ]
      const res = await dispatch(amcPerformanceDownload({ jsonData: formatExportedData, sheetName: "amc" })) as unknown as any;
      reportDownload(res as unknown as Blob, 'amcPerformanceReport.xlsx');
    } catch (e) {
      console.log("Error", e)
    } finally {
      setAmcDownloadLoader(false);
    }
  }

  const handleExploreMutualFunds = () => {

    dispatch(setSelectedAllHoldingsInfo([]))

    dispatch(setAppliedFundsFilters([]));
    dispatch(setSelectedSchemesObj({}));
    dispatch(setExploreMutualFundsPageVisited(false));

    dispatch(setAppliedHoldingsFilters([]))
    dispatch(setHoldingsActiveCategory("All"))
    dispatch(setSelectedHoldingsIds([]))
    dispatch(setCheckedHoldingSchemes([]))
    dispatch(setSelectedHoldingsInfo([]))

    dispatch(setSystematicPlansSearchText(""))
    dispatch(setAppliedSystematicPlansFilters([]))

    history.push(`${pathName}/explore`, {
      hideCheckBox: true
      // clientCode: navState?.clientCode || ""
    })
  }

  return (
    <>

      <Box sx={{ width: '100%' }}>
        <Box
          sx={{
            display: {
              xs: 'flex',
              md: 'block',
            },
            justifyContent: {
              xs: 'flex-end',
            },
            alignItems: {
              xs: 'center',
            },
            flexWrap: 'wrap',
            rowGap: 1,
          }}
        >
          <BreadCrum array={rmRouterPath} />

          <Box
            sx={{
              display: 'flex',
              justifyContent: {
                xs: 'flex-end',
                md: 'flex-end',
              },
              width: {
                xs: 'auto',
                md: '100%',
              },
              alignItems: 'center',
            }}
          >
            <Button
              onClick={handleExploreMutualFunds}
              variant="contained"
              sx={(theme: Theme) => ({
                borderRadius: "10px",
                padding: {
                  xs: "6px 22px",
                  md: "10px 15px"
                },
                backgroundColor: theme.palette.primary[500],
                color: theme.palette.textDark.primary,
                maxWidth: '250px',
                "&.Mui-disabled": {
                  backgroundColor: `${theme.palette.text.secondary}B2`,
                  color: theme.palette.text.secondary,
                },
                "&:hover": {
                  backgroundColor: 'customColors.blackishGrey90',
                },
                flexWrap: 'nowrap',
                height: {
                  xs: "42px", //mobile height
                  md: "auto" //desktop hei
                }
              })}
            >
              Explore <Hidden only="xs"> Mutual Funds</Hidden>
            </Button>
          </Box>
        </Box>
      </Box>

      {
        // *** Filter Disabled for the time being
        /* {!filterElementLoading && (
        <FilterPortal>
          <Box sx={{ display: 'flex' }}>
            <IconButton aria-label="Open filters" onClick={(e) => setFilterMenuAnchorEl(e.currentTarget)}>
              <img src="/images/filter.svg" alt="filter" />
            </IconButton>
          </Box>
          <FilterDrawer
            selectedFilters={selectedFilters}
            setSelectedFilters={setSelectedFilters}
            open={filterMenuOpen}
            anchorEl={filterMenuAnchorEl}
            onClose={() => setFilterMenuAnchorEl(null)}
          />
        </FilterPortal>
      ) */
      }

      {/* <DashboardLayout 
        // location={location}
      //  location={investorName}
      
        >    */}
      {/* <Box>
          <Box
            sx={{
              background: '#EEF9F4',
              borderRadius: '16px',
              px: 3,
              py: 1.5,
              mb: 2.5,
            }}>
            <Breadcrumbs
              separator={<NavigateNextIcon fontSize="small" />}
              aria-label="breadcrumb"
              sx={{
                '& .MuiTypography-root': {
                  fontSize: 20,
                  lineHeight: '23px',
                  fontWeight: 500,
                  color: '#767676',
                  '&.MuiTypography-body1': { color: '#22242C' },
                },
                '& .MuiBreadcrumbs-separator': {
                  '& .MuiSvgIcon-root': { color: 'rgba(0,0,0,0.6)' },
                  '&:last-of-type': {
                    background: 'red',
                    '& .MuiSvgIcon-root': { color: '#22242C' },
                  },
                },
              }}>
              {breadcrumbs}
            </Breadcrumbs>
          </Box>
          <Box
            sx={{
              width: '100%',
              '& .MuiTabPanel-root': { py: 4, px: 0 },
              '& .MuiTab-root': {
                color: '#636363',
                opacity: 0.8,
                fontSize: 17,
                lineHeight: '24px',
                textTransform: 'capitalize',
                px: { xs: 2, md: 3, lg: 5 },
                '&.Mui-selected': {
                  color: '#4B81B1',
                },
              },
              '& .MuiTabs-indicator': {
                height: 3,
                background: '#4B81B1',
              },
            }}>
            <TabContext value={value}>
              <Box>
                <TabList
                  onChange={handleChange}
                  aria-label="product tabs"
                  variant="scrollable"
                  scrollButtons="auto">
                  <Tab label="Overview" value="overview" />
                  {assetTypes.includes('equity') && <Tab label="Equity" value="equity" />}
                  {assetTypes.includes('hybrid') && <Tab label="Hybrid" value="hybrid" />}
                  {assetTypes.includes('debt') && <Tab label="Debt" value="debt" />}
                  <Tab label="Scheme Details" value="scheme-details" />
                  <Tab label="Transaction Details" value="transaction-details" />
                </TabList>
              </Box>
              <TabPanel value="overview">
                <>
                  {filtersSelected.length ? selectedFilterElements : null}
                  <ProductOverview
                    investorId={investorId}
                    selectedFilters={selectedFilters}
                    setAssetTypes={setAssetTypes}
                  />
                </>
              </TabPanel>
              <TabPanel value="equity">
                <>
                  {filtersSelected.length ? selectedFilterElements : null}
                  <ProductEquity investorId={investorId} selectedFilters={selectedFilters} />
                </>
              </TabPanel>
              <TabPanel value="hybrid">
                <>
                  {filtersSelected.length ? selectedFilterElements : null}
                  <ProductEquity
                    investorId={investorId}
                    selectedFilters={selectedFilters}
                    forHybrid={true}
                  />
                </>
              </TabPanel>
              <TabPanel value="debt">
                <>
                  {filtersSelected.length ? selectedFilterElements : null}
                  <ProductDebt investorId={investorId} selectedFilters={selectedFilters} />
                </>
              </TabPanel>
              <TabPanel value="scheme-details">
                <>
                  {filtersSelected.length ? selectedFilterElements : null}
                  <SchemeDetails investorId={investorId} selectedFilters={selectedFilters} />
                </>
              </TabPanel>
              <TabPanel value="transaction-details">
                <>
                  {filtersSelected.length ? selectedFilterElements : null}
                  <TransactionDetails investorId={investorId} selectedFilters={selectedFilters} />
                </>
              </TabPanel>
            </TabContext>
          </Box>
        </Box> */}
      {/* </DashboardLayout> */}
      <Box>

        {/* Cards */}
        <Grid container spacing={2} mt={'25px'}>
          {mutualFundCardObj.data.map((obj: SidebarCardProps) => (
            <Grid
              item
              key={obj.title}
              xs={12}
              md={6}
              lg={3}
            >
              <InfoCard
                Icon={obj.Icon}
                title={obj.title}
                value={obj.value}
                valueTextColor={obj?.valueTextColor}
                isLoading={cardValuesLoading}
                percentage={obj.percentage}
              />
            </Grid>
          ))}
        </Grid>

        {/* Tabs */}

        <Box sx={{ mt: '45px', borderBottom: `1px solid ${palette.customColors.pastelGrey}`, padding: '0 0 15px 0' }}>
          {productMutualFundTabs?.map((tab: string, index: number) => (
            <Button sx={(theme: Theme) => ({
              padding: '5px 15px',
              borderRadius: '7px',
              cursor: 'pointer',
              mr: '10px'
            })} variant={mutualFundTab === tab ? 'contained' : 'text'} key={index} onClick={() => handleTabChange(tab)}
              disabled={portfolioNotExistStatus}
            >
              <Typography variant='body_500' sx={(theme: Theme) => ({
                color: mutualFundTab === tab ? theme.palette.textDark.primary : theme.palette.text.secondary,
                letterSpacing: '0.02px',
                lineHeight: '20px'
              })}>{tab}</Typography>
            </Button>
          ))}
        </Box>

        <Box mt={'25px'}>
          {(!isLoading && portfolioNotExistStatus) ?
            <Box
              sx={(theme: Theme) => ({
                backgroundColor: theme.palette.common.white,
                borderRadius: "25px",
                padding: "25px 30px",
                height: "50vh"
              })}
            >
              <ZeroStateInvestment isSuccess={mutualFundCardObj.isSuccess} />
            </Box>
            : (
              <>
                {mutualFundTab === 'Overview' &&
                  <ProductOverview
                    getProductsOverviewDetails={getProductsOverviewDetails}
                    getProductLevelAMCPerformance={getProductLevelAMCPerformance}
                    productsOverviewLoader={productsOverviewLoader}
                    setProductsOverviewLoader={setProductsOverviewLoader}
                    productsOverviewData={productsOverviewData}
                    setProductsOverviewData={setProductsOverviewData}
                    sebiAllocationData={sebiAllocationData}
                    setSebiAllocationData={setSebiAllocationData}
                    amcPerformanceData={amcPerformanceData}
                    setAmcPerformanceData={setAMCPerformanceData}
                    sortingObj={sortingObj}
                    setSortingObj={setSortingObj}
                    amcSortingObj={amcSortingObj}
                    setAMCSortingObj={setAMCSortingObj}
                    amcLoader={amcLoader}
                    amcDownloadLoader={amcDownloadLoader}
                    amcDownloadHandler={amcDownloadHandler}
                    setAmcDownloadLoader={setAmcDownloadLoader}
                    assetLoading={assetLoading}
                  />}
                {mutualFundTab === 'Scheme Details' &&
                  <SchemeDetails
                    schemeDetailsLoading={schemeDetailsLoading}
                    setSchemeDetailsLoading={setSchemeDetailsLoading}
                    tableData={tableData}
                    setTableData={setTableData}
                    tablePaginationObj={tablePaginationObj}
                    setTablePaginationObj={setTablePaginationObj}
                    fetchSchemeDetailsData={fetchSchemeDetailsData}
                    schemeDetailsData={schemeDetailsData}
                  />}
                {mutualFundTab === 'Transaction Details' &&
                  <TransactionDetails
                    transactionDetailsLoading={transactionDetailsLoading}
                    setTransactionDetailsLoading={setTransactionDetailsLoading}
                    transactionTableData={transactionTableData}
                    setTransactionTableData={setTransactionTableData}
                    transactionDetailPaginationObj={transactionDetailPaginationObj}
                    setTransactionDetailPaginationObj={setTransactionDetailPaginationObj}
                    fetchTransactionDetailsData={fetchTransactionDetailsData}
                    transactionDetailsData={transactionDetailsData}
                  />}
              </>)}

        </Box>
      </Box>

    </>
  );
}
